import { Minus, Plus, Trash2 } from "lucide-react";

interface CartItemProps {
  id: string;
  name: string;
  variant: string;
  price: number;
  originalPrice?: number;
  quantity: number;
  image: string;
  currency?: string;
  discountPercentage?: number;
  onUpdateQuantity: (id: string, quantity: number) => void;
  onRemove: (id: string) => void;
}

export const CartItem = ({
  id,
  name,
  variant,
  price,
  originalPrice,
  quantity,
  image,
  currency = "€",
  discountPercentage = 0,
  onUpdateQuantity,
  onRemove,
}: CartItemProps) => {
  // Check if item has its own discount OR if cart-wide coupon discount applies
  const hasItemDiscount = originalPrice && originalPrice > price;
  const hasCouponDiscount = discountPercentage > 0;
  
  // Calculate display prices
  const basePrice = hasItemDiscount ? originalPrice : price;
  const finalPrice = hasCouponDiscount ? price * (1 - discountPercentage / 100) : price;

  return (
    <div className="cart-item">
      <div className="w-20 h-20 rounded-lg overflow-hidden bg-secondary flex-shrink-0">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover"
        />
      </div>
      
      <div className="flex-1 min-w-0">
        <div className="flex justify-between items-start gap-2 mb-1">
          <h4 className="text-sm font-medium text-foreground line-clamp-2">
            {name}
          </h4>
          <div className="text-right whitespace-nowrap">
            {(hasItemDiscount || hasCouponDiscount) ? (
              <>
                <span className="text-sm font-semibold text-foreground">
                  {(finalPrice * quantity).toFixed(2).replace(".", ",")} {currency}
                </span>
                <div className="text-xs text-muted-foreground line-through">
                  {(basePrice * quantity).toFixed(2).replace(".", ",")} {currency}
                </div>
              </>
            ) : (
              <span className="text-sm font-semibold text-foreground">
                {(price * quantity).toFixed(2).replace(".", ",")} {currency}
              </span>
            )}
          </div>
        </div>
        
        <p className="text-xs text-primary mb-3">
          {variant}
        </p>
        
        <div className="flex items-center gap-3">
          <div className="quantity-selector">
            <button
              onClick={() => onUpdateQuantity(id, Math.max(1, quantity - 1))}
              className="quantity-btn"
              disabled={quantity <= 1}
            >
              <Minus className="w-3.5 h-3.5" />
            </button>
            <span className="w-8 text-center text-sm font-medium">
              {quantity}
            </span>
            <button
              onClick={() => onUpdateQuantity(id, quantity + 1)}
              className="quantity-btn"
            >
              <Plus className="w-3.5 h-3.5" />
            </button>
          </div>
          
          <button
            onClick={() => onRemove(id)}
            className="text-xs text-muted-foreground hover:text-destructive transition-colors underline underline-offset-2"
          >
            Odstrániť
          </button>
        </div>
      </div>
    </div>
  );
};
